module.exports = __webpack_public_path__ + "img/dex-hanging.b2a37619.svg";